import type { ReactElement } from 'react';
import { Belen, GoldTree, Mistletoe, Parol } from './art';
import './christmas.css';
import { useDecorOn } from './useChristmas';

/**
 * Hanging parols, drawn in the top bar's spacer (the free space between the
 * page title and the controls). They hang from the bar's top edge and never
 * take a click. Renders nothing out of season or when the person switched it off.
 */
export function TopbarDecor(): ReactElement | null {
  const on = useDecorOn();
  if (!on) return null;
  const parols: { x: number; y: number; r: number; colors: [string, string] }[] = [
    { x: 30, y: 22, r: 11, colors: ['#f4b740', '#d9572f'] },
    { x: 80, y: 16, r: 8, colors: ['#f6d070', '#c9852a'] },
    { x: 125, y: 26, r: 10, colors: ['#f08c5a', '#b8323a'] },
  ];
  return (
    <div className="xmas-topbar" aria-hidden="true" data-xmas="topbar">
      <svg viewBox="0 0 150 72">
        {parols.map((parol, index) => (
          <g key={parol.x}>
            <line
              x1={parol.x}
              y1="0"
              x2={parol.x}
              y2={parol.y - parol.r * 1.1}
              stroke="#b9a37a"
              strokeWidth="1"
            />
            <g className="xmas-glow" style={{ animationDelay: `${(index * 0.8).toFixed(1)}s` }}>
              <Parol cx={parol.x} cy={parol.y} r={parol.r} colors={parol.colors} />
            </g>
          </g>
        ))}
      </svg>
    </div>
  );
}

/** Sidebar footer: gold mistletoe, a big parol over the belen, a small gold tree. */
export function SidebarScene(): ReactElement | null {
  const on = useDecorOn();
  if (!on) return null;
  return (
    <div className="xmas-scene" aria-hidden="true" data-xmas="scene">
      <svg viewBox="0 0 204 190">
        <Mistletoe x={150} y={0} width={34} />
        <g className="xmas-glow">
          <Parol cx={90} cy={40} r={30} colors={['#f4b740', '#d9572f']} />
        </g>
        <Belen x={4} y={80} scale={0.95} />
        <GoldTree cx={172} base={182} h={64} />
      </svg>
      <div className="xmas-scene-cap">Maligayang Pasko</div>
    </div>
  );
}
